import React, { useState, useEffect } from 'react';
import { Rate, Input, Spin, Checkbox } from 'antd';
import { isEmptyObj, openNotificationInToast } from '../utilities';
import { chapterReviewService, ratingReviewService } from '../services/apiServices';

const { TextArea } = Input;

function CourseRatings({ showPopup, closePopup, ratingFor, payloads, productType }) {
  const [reviewText, setReviewText] = useState('');
  const [rating, setRating] = useState(0);
  const [reviewData, setReviewData] = useState({});
  const [overallData, setOverallData] = useState({});
  const [loading, setLoading] = useState(false);
  const [preFilledReview, setPreFilledReview] = useState([]);
  const [showCommentBox, setShowCommentBox] = useState(false);

  useEffect(() => {
    fetchRatingReview()
  }, [productType])

  useEffect(() => {
    setReviewData({});
    if (showPopup) {
      starChange(5);
    }
    setPreFilledReview([]);
    setReviewText('');
    setShowCommentBox(false);
  }, [showPopup]);

  const starChange = (value) => {
    if (!value) {
      return
    }
    setPreFilledReview([]);
    setShowCommentBox(false);
    setReviewText('');
    // setLoading(true);
    setRating(value);
    setReviewData(overallData[value])
  };

  const feedbackText = (value) => {
    setReviewText(value);
  };

  const avoidSpace = (event) => {
    if (event.target.value.length > 1 && event.target.value.indexOf(' ') >= 0) {
      if (event.which === 32) {
        return false;
      } else {
        return true;
      }
    }
  };
  const sendReview = () => {
    const reviews = getPreFilledReview();
    if (rating !== 0 && reviews.length > 0) {
      let data = {
        chapterId: payloads.widgetId,
        chapterRating: rating,
        comment: reviews,
      };
      chapterReviewService(data)
        .then((response) => {
          setReviewText('');
          setRating(0);
          openNotificationInToast('success', 'Success!', 'Thanks for submitting your review.');
          closePopup();
        })
        .catch((error) => {
          console.error(error);
          setReviewText('');
          setRating(0);
          openNotificationInToast('success', 'Success!', 'Thanks for submitting your review.');
          closePopup();
        });
    }
  };

  const fetchRatingReview = () => {
    ratingReviewService(productType)
      .then((response) => {
        setOverallData(response[productType])
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleOthersChecked = (e) => {
    const { checked } = e.target;
    setShowCommentBox(checked);
  }

  const handleCheckboxChange = (e, items) => {
    const { checked } = e.target;
    if (checked) {
      if (preFilledReview.length === 0) {
        setPreFilledReview([items]);
      } else if (preFilledReview.indexOf(items) < 0) {
        setPreFilledReview([...preFilledReview, items]);
      }
    } else {
      const filtered = preFilledReview.filter((items2) => items2 !== items);
      setPreFilledReview(filtered);
    }
  };

  const getPreFilledReview = () => {
    let reviews = [];
    if (showCommentBox && reviewText) {
      reviews.push(reviewText.trim());
    }
    preFilledReview.forEach((items) => {
      reviews.push(items);
    });
    return reviews.join(', ');
  };

  return (
    <div className='review-popup_wrapper course-rating-popup' style={showPopup ? { display: 'flex' } : { display: 'none' }}>
      <div className='review-popup'>
        <div className='review-popup-heading'>Share us your feedback</div>
        <hr className='review-popup-separator'/>
        {reviewData.ratingEmoji && <img src={reviewData.ratingEmoji} width={60} height={60} alt='Rating Emoji' />}
        <span onClick={closePopup} className='review-popup-close'>X</span>
        <div className='ratingLoader'>{loading && <Spin />}</div>
        {!isEmptyObj(reviewData) && (
          <div className='ratingReviewPreloaded'>
            <h3>{reviewData.ratingTitle}</h3>
            <Rate onChange={starChange} value={rating} />
            <p>{reviewData.ratingSubTitle}</p>
            <div className='ratingReviewCheckboxs'>
              {reviewData.reviewTitles &&
                reviewData.reviewTitles.map((items, idx) => {
                  return (
                    <Checkbox key={idx} checked={items.indexOf('Others') >= 0 ? showCommentBox : preFilledReview.indexOf(items) >=0} onChange={(e) => items.indexOf('Others') >= 0 ? handleOthersChecked(e) : handleCheckboxChange(e, items)}>
                      {items}
                    </Checkbox>
                  );
                })}
            </div>
          </div>
        )}
        {showCommentBox && (
          <TextArea
            value={reviewText}
            type='textarea'
            // autoSize={{ minRows: 2, maxRows: 3 }}
            placeholder='Please specify...'
            allowClear
            onChange={(ev) => feedbackText(ev.target.value)}
            onKeyPress={avoidSpace}
            size='large'
            className='feebackTextbox'
          />
        )}
        <div className='review-buttons'>
          <button onClick={sendReview} disabled={rating === 0 || ((preFilledReview.length === 0 && !showCommentBox) || (showCommentBox && reviewText.length < 3))} className='review-button review-button-submit'>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default CourseRatings;
